/**
 * Grand Quack Auto — "CARJACK" proximity hint.
 *
 * Tiny GTA-style HUD card that pops up when the duck is within range of a
 * driveable car. Picks a random brainrot flavor line each spawn, mounts an
 * E-key badge, and tears itself down on hide. Reuses the .key-badge and
 * .mission-sub CSS tokens defined in index.html for visual consistency.
 *
 * Extracted from vehicleSystem.ts so that file stays under the project's
 * 200-line cap (CLAUDE.md).
 */

let carHintEl: HTMLElement | null = null;

const CAR_HINTS = [
  'Commit grand theft auto 🚗',
  'This duck needs wheels 🦆',
  "It's not stealing, it's borrowing 🚗",
  "Ducks can't get speeding tickets 🏎️",
  'Enter your getaway vehicle 🚨',
];

export function showCarHint(): void {
  if (carHintEl) return;
  const hud = document.getElementById('hud');
  if (!hud) return;
  const flavor = CAR_HINTS[Math.floor(Math.random() * CAR_HINTS.length)]!;
  carHintEl = document.createElement('div');
  carHintEl.id = 'car-hint';
  carHintEl.innerHTML =
    `<div class="key-row"><span class="key-badge">E</span><span>CARJACK</span></div>` +
    `<span class="mission-sub">Dispatch: ${flavor}</span>`;
  hud.appendChild(carHintEl);
}

export function hideCarHint(): void {
  if (carHintEl) { carHintEl.remove(); carHintEl = null; }
}
